<template> 
  <div>
    <div class="position-relative" v-if="adminSummaryPermissions">
      <app-overlay-loader v-if="preloader" />

      <!-- First row of 4 cards -->
      <div class="row mb-primary" :class="{ 'loading-opacity': preloader }">
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_employees')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('total_employees')"
            :number="integerFormatter(cardSummaries.total_employee)"
            icon="user"
          />
        </div>

        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_departments')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('total_departments')"
            :number="integerFormatter(cardSummaries.total_department)"
            icon="home"
          />
        </div>

        <div class="col-sm-6 col-lg-3 mb-4 mb-sm-0" v-if="$can('view_all_leaves')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('total_leave_requests')"
            :number="integerFormatter(cardSummaries.total_leave_request)"
            icon="edit"
          />
        </div>

        <div class="col-sm-6 col-lg-3 mb-4 mb-sm-0" v-if="$can('view_all_leaves')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('on_leave_today')"
            :number="integerFormatter(cardSummaries.on_leave_today)"
            icon="user-x"
          />
        </div>
      </div>

      <!-- Second row of 4 cards -->
      <div class="row mb-primary" :class="{ 'loading-opacity': preloader }">
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_expenses')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('total_expense_this_year')"
            :number="numberFormatter(cardSummaries.total_expense_year)"
            icon="dollar-sign"
          />
        </div>

        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_incomes')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('total_income_this_year')"
            :number="numberFormatter(cardSummaries.total_income_year)"
            icon="credit-card"
          />
        </div>

        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_projects')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('total_projects')"
            :number="integerFormatter(cardSummaries.total_projects)"
            icon="folder"
          />
        </div>

        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_clients')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('total_clients')"
            :number="integerFormatter(cardSummaries.total_clients)"
            icon="users"
          />
        </div>
      </div>

      <!-- Third row with Client Monthly Due -->
      <div class="row mb-primary" :class="{ 'loading-opacity': preloader }">
        <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0" v-if="$can('view_clients')">
          <app-widget
            type="app-widget-with-icon"
            :label="$t('client_monthly_due')"
            :number="integerFormatter(cardSummaries.client_monthly_due)"
            icon="alert-circle"
          />
        </div>
      </div>
    </div>

    <!-- Rest of your template -->
    <div class="row">
      <div
        class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9 mb-4 mb-md-0"
        v-if="employeeStatisticsPermissions"
      >
        <app-employee-statistics />
      </div>
      <div
        class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3"
        v-if="attendancePermissions"
      >
        <on-working-today />
      </div>
    </div>
  </div>
</template>

<script>
import { numberFormatter } from "../../../../../common/Helper/Support/SettingsHelper";
import { axiosGet } from "../../../../../common/Helper/AxiosHelper";
import { APP_DASHBOARD } from "../../../../Config/ApiUrl";
import OnWorkingToday from "./OnWorkingToday";

export default {
  name: "AdminDashboard",
  components: { OnWorkingToday },
  data() {
    return {
      numberFormatter,
      preloader: false,
      cardSummaries: {},
    };
  },
  created() {
    this.getSummeryData();
  },
  methods: {
    getSummeryData() {
      this.preloader = true;
      axiosGet(`${APP_DASHBOARD}/summery`).then(({ data }) => {
        this.cardSummaries = data;
        this.preloader = false;
      });
    },
    integerFormatter(input) {
      if (input === null || input === undefined) return "0";
      let number = Number(input);
      if (isNaN(number)) return "0";
      return number.toString(); // always integer
    },
  },
  computed: {
    adminSummaryPermissions() {
      return (
        this.$can("view_employees") ||
        this.$can("view_departments") ||
        this.$can("view_all_leaves") ||
        this.$can("view_expenses") ||
        this.$can("view_incomes") ||
        this.$can("view_projects") ||
        this.$can("view_clients")
      );
    },
    employeeStatisticsPermissions() {
      return (
        this.$can("view_employment_statuses") ||
        this.$can("view_designations") ||
        this.$can("view_departments")
      );
    },
    attendancePermissions() {
      return this.$can("view_all_attendance");
    },
  },
};
</script>

<style scoped>
/* Styles */
</style>
